import { render, staticRenderFns } from "./ParticipantsDashboard.vue?vue&type=template&id=2f4bfb25&"
import script from "./ParticipantsDashboard.vue?vue&type=script&lang=js&"
export * from "./ParticipantsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCheckbox,VOverlay,VProgressCircular})
